import { lazy } from "react";

export type { IAddToCollectionPopupProps } from "./types";

export const AddToCollectionPopup = lazy(() => import("./AddToCollectionPopup"));
